/**
 * @file コンポーネント：フル動画ページタイムラインアイテム ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useRef, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const TimelineItem = (props) => {
    /**
     * ポップアップシェーマアイコンにホバー時、マウスオーバーstyleを適用する
     */
    const [isMouseOverPopupSchemaButton, setIsMouseOverPopupSchemaButton] =
        useState(false);
    const refTimelineItemButton = useRef(null);
    useEffect(() => {
        const isActive =
            refTimelineItemButton?.current?.classList.contains("is-active");
        if (isMouseOverPopupSchemaButton && !isActive) {
            refTimelineItemButton?.current?.classList.add("is-mouseover");
        } else {
            refTimelineItemButton?.current?.classList.remove("is-mouseover");
        }
    }, [isMouseOverPopupSchemaButton]);

    /**
     * 編集モーダルに渡す処理対象DOMを指定
     */
    const refTimelineItem = useRef(null);
    const refTimelineItemText = useRef(null);

    return (
        <Presenter
            {...props}
            refTimelineItem={refTimelineItem}
            refTimelineItemButton={refTimelineItemButton}
            refTimelineItemText={refTimelineItemText}
            setIsMouseOverPopupSchemaButton={setIsMouseOverPopupSchemaButton}
        />
    );
};
